import Button from '@builder4/shared/components/Button';
import Container from '@builder4/shared/components/Container';
import Countdown from '@builder4/shared/components/Countdown';
import Embed from '@builder4/shared/components/Embed';
import Form, {
  FormConsentField,
  FormDropdownField,
  FormEmailField,
  FormPhoneField,
  FormSelectionField,
  FormSubmitButton,
  FormTextField,
} from '@builder4/shared/components/Form';
import Icon from '@builder4/shared/components/Icon';
import Image from '@builder4/shared/components/Image';
import Page from '@builder4/shared/components/Page';
import Popup from '@builder4/shared/components/Popup';
import Text from '@builder4/shared/components/Text';
import Video from '@builder4/shared/components/Video';

/**
 * Resolver mapping component names to their implementations for all non-editor
 * render contexts (server-side rendering, section thumbnails, inspiration previews).
 *
 * NOTE: The main editor uses a separate resolver (packages/frontend/src/utils/helperFunc.ts)
 * that maps to editor-wrapped components (EditorButton, EditorContainer, etc.) and
 * includes additional editor-only components like AiGenerationLoader.
 */
export const componentResolver = {
  Button,
  Container,
  Countdown,
  Embed,
  Form,
  FormConsentField,
  FormDropdownField,
  FormEmailField,
  FormPhoneField,
  FormSelectionField,
  FormSubmitButton,
  FormTextField,
  Icon,
  Image,
  Page,
  Popup,
  Text,
  Video,
};
